import React, {useCallback} from "react"
import HayaSelect from "components/woof-haya-select"
import memo from "set-state-compare/build/memo"
import {sortedByFunction} from "sorted-by"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import useInput from "@kaspernj/api-maker/build/use-input"
import {User} from "models"
import {withInputContainer} from "components/inputs/input-container"

const ComponentsUserAdminSchoolClassesEditTeachersSelect = (props) => {
  const {inputProps, restProps} = useInput({props, wrapperOptions: {type: "select"}})
  const {label, school, ...actualRestProps} = restProps
  const {t} = useI18n({namespace: "js.components.user.admin.school_classes.edit.teachers_select"})
  const optionsCallback = useCallback(async ({searchValue, values}) => {
    const teachersQuery = User
      .ransack({
        associated_with_school_ids: school.id(),
        s: "contact_first_name"
      })
      .select({User: ["id", "name"]})
      .groupBy("id")

    if (searchValue) teachersQuery.ransack({contact_first_name_or_contact_last_name_cont_any_word: searchValue})
    if (values) teachersQuery.ransack({id_eq_any: values})

    let teachers = await teachersQuery.toArray()

    teachers = sortedByFunction(teachers, "name")

    const options = []

    options.push({
      optionType: "create-new-teacher",
      text: t(".create_new_teacher"),
      value: "create-new-teacher"
    })

    options.push({
      key: "teachers-group",
      text: t(".teachers"),
      type: "group"
    })

    for (const teacher of teachers) {
      options.push({
        optionType: "teacher",
        text: teacher.name(),
        value: teacher.id()
      })
    }

    return options
  }, [])

  const {ref, ...restInputProps} = inputProps

  return (
    <HayaSelect
      options={optionsCallback}
      {...restInputProps}
      {...actualRestProps}
    />
  )
}

export default withInputContainer(memo(ComponentsUserAdminSchoolClassesEditTeachersSelect))
